import { NgModule } from '@angular/core';
import { OnlyNumber } from "./onlynumber.directive";
import { SpecialCharacter } from "./onlychar.directive";
import { onlycharSpecialCharacter } from './onlycharSpecial.directive';
import { onlynumberSpecialCharacter } from './onlynumberSpecial.directive';
import { inputText } from './inputtext.directive';
import { PasswordOnly } from './password.directive';
import { TimeOnly } from './time.directive';
import { RoleDirective } from './role.directive';
import { CommaseperatorDirective } from './commaseperator.directive';
import { OnlytextDirective } from './onlytext.directive';
import { NoLeadingSpaceDirectiveDirective } from './no-leading-space-directive.directive';

export const components = [
  OnlytextDirective,
  OnlyNumber,
  SpecialCharacter,
  onlycharSpecialCharacter,
  onlynumberSpecialCharacter,
  inputText,
  PasswordOnly,
  TimeOnly,
  RoleDirective,
  CommaseperatorDirective,NoLeadingSpaceDirectiveDirective

];

@NgModule({
  declarations: [components,],
  exports: [components]
})
export class DirectivesModule { }
